import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // },
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/home/index')
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('@/views/about/index')
    },
    {
      path: '/service',
      name: 'Service',
      component: () => import('@/views/service/index')
    },
    {
      path: '/cases',
      name: 'Cases',
      component: () => import('@/views/cases/index')
    },
    {
      path: '/software',
      name: 'Software',
      component: () => import('@/views/software/index')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js